import { useGetUser, useGetEntitlements, useTeamInfo } from 'src/hooks';
import styles from './RemainingTasksSection.module.scss';
import { SUPER_PROJECT_NAME } from 'src/constants';
import { useGetCreditAccountInfoQuery } from 'src/store/services';
import { CreditAccountKeysStatus } from 'src/types/wallet/models/CreditAccountKeysStatus';

export const RemainingSuperNinjaTasksSection = () => {
  const {
    isMaxTier,
    isSuperNinjaUltraTrialTier,
    isFreeTier,
    isTeamsTier,
    user_id,
  } = useGetUser();
  const { isOwner } = useTeamInfo();

  const { entitlement } = useGetEntitlements();

  const { query_balance, superninja_queries_per_24h_balance } =
    entitlement || {};
  const { total_queries_quota, total_queries_available } = query_balance || {};

  const { data: creditAccountInfo, isLoading: isCreditAccountInfoLoading } =
    useGetCreditAccountInfoQuery(
      {
        user_id: user_id,
      },
      {
        skip: (isTeamsTier && !isOwner) || total_queries_available !== 0,
      },
    );

  const requestsPerBillingCycle = total_queries_quota;

  const isComplementaryPerMonth = !isMaxTier;
  const isUnlimited = total_queries_quota === -1;

  const numberOfRemainingTasks =
    isCreditAccountInfoLoading || !(total_queries_available >= 0)
      ? '-'
      : total_queries_available === 0 &&
          creditAccountInfo?.keys_status === CreditAccountKeysStatus.ACTIVE
        ? '$'
        : total_queries_available;

  const remainingPaidPerBillingCycle = isCreditAccountInfoLoading
    ? '-'
    : total_queries_available === -1
      ? 'Unlimited'
      : numberOfRemainingTasks;

  return (
    <div className={styles.container}>
      <p className={styles.titleContainer}>
        <span className={styles.title}>{SUPER_PROJECT_NAME} tasks</span>

        {isUnlimited ? (
          <span className={styles.value}>Unlimited</span>
        ) : (
          <span className={styles.value}>
            {isFreeTier
              ? `${remainingPaidPerBillingCycle} tasks (${superninja_queries_per_24h_balance} today)`
              : remainingPaidPerBillingCycle}
          </span>
        )}
      </p>

      {!isUnlimited && (
        <p className={styles.description}>
          {isComplementaryPerMonth ? (
            <span>
              {`Complementary ${requestsPerBillingCycle} tasks per month`}
            </span>
          ) : (
            `Auto-refill ${requestsPerBillingCycle} tasks ${isSuperNinjaUltraTrialTier ? 'per trial duration' : 'on billing period.'}`
          )}
        </p>
      )}
    </div>
  );
};
